import { NPCS } from '../../content/npcs';
import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { bump, openPanel } from '../../ui/app/store';
import './economy.css';
import { unreadCount } from './mail';
import { MailPanel } from './MailPanel';
import { processListings, refreshMarket } from './market';
import { MarketPanel } from './MarketPanel';
import { ShopPanel } from './ShopPanel';
import { setGame } from './ui';

export { SHOPS, registerShop, resolveShop } from './shops';
export { sendMail } from './mail';

/**
 * Gives an NPC without a shop the "Browse wares" service for `shopId`. Used
 * for the endgame token exchanges until the NPC data lists them directly.
 */
export function attachExchange(npcId: string, shopId: string): void {
  const npc = NPCS[npcId];
  if (!npc || npc.shop) return;
  npc.shop = shopId;
  if (!npc.services.includes('shop')) npc.services.push('shop');
}

/** Shops (`shop`), the market (`market`) and the mailbox (`mail`). */
export function install(game: Game): void {
  setGame(game);
  registerPanel('shop', ShopPanel);
  registerPanel('market', MarketPanel);
  registerPanel('mail', MailPanel);
  attachExchange('rift_scholar_elowen', 'rift_scholar');

  game.hud.addMenuButton('Mail', '✉', () => openPanel('mail'));
  const mailBtn = game.hud.menuBar.lastElementChild as HTMLElement | null;
  mailBtn?.classList.add('fx-mail-btn');

  let t = 0;
  let lastUnread = -1;
  game.systems.push((g, dt) => {
    t += dt;
    if (t < 1) return;
    t = 0;
    const a = g.account;
    let changed = refreshMarket(a);
    const sold = processListings(a);
    for (const s of sold)
      g.hud.toast(
        `Market sale: ${s.listing.count} bundle${s.listing.count > 1 ? 's' : ''} sold — ${s.net.toLocaleString('en-US')} gold by mail`,
        '#f1c33f',
      );
    if (sold.length) changed = true;
    const unread = unreadCount(a);
    if (unread !== lastUnread && mailBtn) {
      lastUnread = unread;
      mailBtn.dataset.unread = unread > 0 ? String(unread) : '';
      mailBtn.classList.toggle('has-unread', unread > 0);
    }
    if (changed) {
      bump();
      g.store.saveSoon(a);
    }
  });
}
